import { useAuth } from '../../contexts/AuthContext';
import { useUserProfile } from '../../hooks/useUserProfile';
import { DEFAULT_LOGO_URL } from '../../constants';

export default function Header() {
  const { user, signOut } = useAuth();
  const { organizationName, logoUrl, activeYear, companyName, companyNumber, businessCountry } = useUserProfile(user);
  const emailLocal = user?.email?.split('@')[0] || '';
  const rawName = emailLocal ? (emailLocal.split('.')[0] || emailLocal) : (user?.displayName?.split(' ')[0] || 'User');
  const displayName = rawName ? rawName.charAt(0).toUpperCase() + rawName.slice(1).toLowerCase() : 'User';

  // Use custom logo if available, otherwise default Svenry logo
  const logoSrc = logoUrl || DEFAULT_LOGO_URL;

  // Use activeYear from settings, fallback to current year
  const displayYear = activeYear || new Date().getFullYear();

  // Use companyName from settings, fallback to organizationName from Fortnox
  const displayCompanyName = companyName || organizationName;

  return (
    <header className="h-14 bg-white border-b border-gray-200 flex items-center justify-between px-6">
      <div className="flex items-center gap-4">
        <span className="text-gray-700 font-medium">
          Welcome {displayName}
        </span>
        <button
          type="button"
          onClick={signOut}
          className="text-sm text-gray-500 hover:text-gray-700"
        >
          Sign out
        </button>
      </div>
      <div className="flex items-center gap-4">
        <span className="text-sm text-gray-500">
          Year {displayYear}
        </span>
        <div className="flex items-center gap-3">
          {(displayCompanyName || companyNumber || businessCountry) && (
            <div className="text-right">
              {displayCompanyName && (
                <div className="text-sm font-medium text-gray-800 truncate max-w-[200px]" title={displayCompanyName}>
                  {displayCompanyName}
                </div>
              )}
              <div className="flex items-center gap-2 flex-wrap justify-end">
                {companyNumber && (
                  <span className="text-xs text-gray-500 truncate max-w-[200px]" title={companyNumber}>
                    {companyNumber}
                  </span>
                )}
                {businessCountry && (
                  <span className="text-xs text-gray-500 border border-gray-200 rounded px-1.5 py-0.5" title="Country of operation">
                    {businessCountry}
                  </span>
                )}
              </div>
            </div>
          )}
          <img
            src={logoSrc}
            alt={logoUrl ? 'Company logo' : 'Svenry'}
            className="h-8 w-auto object-contain opacity-90 shrink-0"
          />
        </div>
      </div>
    </header>
  );
}
